import {useEffect,useRef,useState} from 'react';
import type {WorldDocument} from '@private-fiction/story-core';
import {useAccountMediaUrl} from './AccountMedia';
import {resolveSceneAmbience} from '../runtime/sceneAmbience';
export function SceneAmbience({documents,muted,onMute}:{documents:readonly WorldDocument[];muted:boolean;onMute:(value:boolean)=>void}) {
  const track=resolveSceneAmbience(documents),source=useAccountMediaUrl(track?.source,true);
  const player=useRef<HTMLAudioElement>(null),[blocked,setBlocked]=useState(false);
  useEffect(()=>{
    const audio=player.current;if(!audio)return;
    let current=true;audio.volume=track?.volume??.35;audio.muted=muted;setBlocked(false);
    if(!source||muted) audio.pause();else void audio.play().catch(()=>{if(current)setBlocked(true);});
    return ()=>{current=false;audio.pause();};
  },[source,muted,track?.volume]);
  if(!track) return null;
  return <div className="scene-ambience"><audio ref={player} src={source||undefined} loop={track.loop} preload="none" /><button aria-label={muted||blocked?'เปิดเสียงประจำฉาก':'ปิดเสียงประจำฉาก'} title={`เสียง: ${track.title}`} onClick={()=>{if(blocked){void player.current?.play().then(()=>setBlocked(false)).catch(()=>setBlocked(true));onMute(false);}else onMute(!muted);}}>{muted||blocked?'♪ เปิดเสียงฉาก':'♪ ปิดเสียงฉาก'}</button></div>;
}
